import {gql} from "@apollo/client";

export const CREATE_MASSIVE_NOTIFICATION = gql`
  mutation CreateNotification($input: CreateNotificationInput!) {
    createMassiveNotification(input: $input) {
      ok
      createdUserNotifications
      skippedExisting
      notification {
        id
        type
        title
        message
        createdAt
        sender {
          id
          fullName
        }
      }
    }
  }
`;

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationAsRead($notificationId: ID!, $profileId: Int!) {
    markNotificationAsRead(notificationId: $notificationId, profileId: $profileId) {
      success
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllNotificationsAsRead($profileId: ID!) {
    markAllNotificationsAsRead(profileId: $profileId) {
      success
    }
  }
`;

export const DELETE_NOTIFICATION = gql`
  mutation DeleteNotification($notificationId: ID!, $profileId: Int!) {
    deleteNotification(notificationId: $notificationId, profileId: $profileId) {
      success
    }
  }
`;

export const DELETE_ALL_NOTIFICATIONS = gql`
  mutation DeleteAllNotifications($profileId: Int!) {
    deleteAllNotifications(profileId: $profileId) {
      success
    }
  }
`;
